import { watch } from 'vue';
import { useRouter } from 'vue-router';

import { RouteNames } from '@/router';
import { useUserStore } from '@/stores/user';

export function useAuthWatcher() {
  const router = useRouter();
  const userStore = useUserStore();

  watch(
    () => userStore.isAuthenticated,
    (isAuthenticated) => {
      if (!isAuthenticated) {
        if (router.currentRoute.value.name !== RouteNames.Login) {
          router.push({
            name: RouteNames.Login,
            query: { startURL: window.location.pathname },
          });
        }
      }
    },
  );

  watch(
    () => userStore.selectedAccount,
    (newAccount, oldAccount) => {
      if (newAccount !== oldAccount) {
        router.replace({ name: RouteNames.Home });
      }
    },
  );
}
